import { MoveLeft, MoveRight } from "lucide-react";

export default function ImpactReportPrevNextNav({prevText, nextText, prevLink, nextLink}) { 
    return(
        <div className='impact-report-prev-next-nav'>
            <div className='container'>
                <div className='impact-report-prev-next-nav__prev'>
                    {prevLink ? (
                        <a href={prevLink} className='impact-report-prev-next-nav__prev-link'>
                            <MoveLeft />
                            <div>
                                <span className='impact-report-prev-next-nav__prev-header'>Previous</span>
                                <span className='impact-report-prev-next-nav__prev-text'>{prevText}</span>
                            </div>
                        </a>
                        ) : null
                    }
                </div>
                <div className='impact-report-prev-next-nav__next'>
                    {nextLink ? (
                        <a href={nextLink} className='impact-report-prev-next-nav__next-link'>
                            <div>
                                <span className='impact-report-prev-next-nav__next-header'>Next</span>
                                <span className='impact-report-prev-next-nav__next-text'>{nextText}</span>
                            </div>
                            <MoveRight />
                        </a>
                        ) : null
                    }
                </div>
            </div>
        </div>
    );
}